( function () {
    var sections = document.querySelectorAll( '.hero-section' );

    if ( ! sections.length || ! ( 'IntersectionObserver' in window ) ) {
        return;
    }

    if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
        return;
    }

    sections.forEach( function ( section ) {
        var trigger = section.querySelector( '.hero-section__eyebrow, .hero-section__title, .hero-section__lead' );
        var announcement = section.querySelector( '.hero-section__announcement' );
        var styles = window.getComputedStyle( section );
        var inset = styles.getPropertyValue( '--hero-section-reveal-inset' ).trim() || '12%';
        var announcementLead = parseDuration( styles.getPropertyValue( '--hero-section-reveal-announcement-lead' ), 550 );
        var copyRevealedAt = null;
        var announcementRevealed = false;
        var observer;
        var resizeTimer;

        if ( ! trigger && ! announcement ) {
            section.setAttribute( 'data-reveal-skip', '' );
            return;
        }

        section.classList.add( 'is-reveal' );

        observer = new IntersectionObserver( function ( entries ) {
            entries.forEach( function ( entry ) {
                if ( entry.isIntersecting && entry.target === trigger ) {
                    revealCopy();
                }
            } );

            entries.forEach( function ( entry ) {
                if ( entry.isIntersecting && entry.target === announcement ) {
                    revealAnnouncement();
                }
            } );
        }, {
            rootMargin: '0px 0px -' + inset + ' 0px',
            threshold: 0
        } );

        // Let the hidden state paint before observing, so content already on screen still animates in.
        window.requestAnimationFrame( function () {
            window.requestAnimationFrame( function () {
                if ( trigger ) {
                    observer.observe( trigger );
                }

                if ( announcement ) {
                    observer.observe( announcement );
                }

                revealIfPageEnds();
            } );
        } );

        onRevealPageEnd( revealIfPageEnds );
        window.addEventListener( 'resize', onResize );

        function onResize() {
            window.clearTimeout( resizeTimer );
            resizeTimer = window.setTimeout( revealIfPageEnds, 150 );
        }

        function revealIfPageEnds() {
            var atEnd = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4;

            if ( ! atEnd ) {
                return;
            }

            revealCopy();
            revealAnnouncement();
        }

        function revealCopy() {
            if ( ! trigger || copyRevealedAt !== null ) {
                return;
            }

            copyRevealedAt = Date.now();
            section.classList.add( 'is-copy-inview' );
            observer.unobserve( trigger );
        }

        function revealAnnouncement() {
            var lead = 0;

            if ( ! announcement || announcementRevealed ) {
                return;
            }

            if ( trigger && copyRevealedAt === null && isOnScreen( trigger ) ) {
                revealCopy();
            }

            if ( copyRevealedAt !== null ) {
                lead = Math.max( 0, announcementLead - ( Date.now() - copyRevealedAt ) );
            }

            announcementRevealed = true;
            observer.unobserve( announcement );
            window.setTimeout( function () {
                section.classList.add( 'is-announcement-inview' );
            }, lead );
        }
    } );

    function onRevealPageEnd( callback ) {
        if ( window.JPSReveal ) {
            window.JPSReveal.onEnd( callback );
            return;
        }

        window.addEventListener( 'scroll', callback, { passive: true } );
    }

    function isOnScreen( element ) {
        var rect = element.getBoundingClientRect();

        return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function parseDuration( raw, fallback ) {
        raw = ( raw || '' ).trim();

        if ( raw.slice( -2 ) === 'ms' ) {
            return parseFloat( raw ) || fallback;
        }

        return ( parseFloat( raw ) * 1000 ) || fallback;
    }
} )();
